import { useMemo } from 'react';
import { User, useAuth0 } from '@auth0/auth0-react';

export interface CustomUserFields {
  userId: number;
  email: string;
  role: string;
  onboarding: boolean;
  logout: boolean;
  connection: AuthUserConnection;
  phoneNumber: string | undefined;
}

export type AuthUserConnection = 'email' | 'sms';

const useAuthUser = () => {
  const { user: auth0User, isAuthenticated, error } = useAuth0();

  const authUser = useMemo(() => {
    if (!auth0User) {
      return undefined;
    }
    const connection = auth0User.sub?.split('|')[0] as AuthUserConnection;

    const impersonationSub = auth0User['https://api.payblox.com/impersonation/sub'];

    const updatedFields = {
      userId: impersonationSub
        ? auth0User['https://api.payblox.com/impersonation/userId']
        : auth0User['https://api.payblox.com/userId'],
      email: impersonationSub
        ? auth0User['https://api.payblox.com/impersonation/email']
        : auth0User['https://api.payblox.com/email'],
      role: impersonationSub
        ? auth0User['https://api.payblox.com/impersonation/roles'][0]
        : auth0User['https://api.payblox.com/roles'][0],
      // role: 'agent',
      onboarding: impersonationSub
        ? auth0User['https://api.payblox.com/impersonation/onboarding']
        : auth0User['https://api.payblox.com/onboarding'],
      logout: !!impersonationSub,
      connection,
      phoneNumber: connection === 'sms' ? auth0User.nickname?.replace(/\D/g, '') : undefined,
    };

    return { ...auth0User, ...updatedFields } as User & CustomUserFields;
  }, [auth0User]);

  return authUser;
};

export default useAuthUser;
